import React from 'react';
import { NavLink, matchPath, useLocation } from 'react-router-dom';
import routes from 'routes';
import { translate } from '../../translations/translator';
import { Typography } from '@mui/material';
import AppsTranslationVariant from 'translations/variants/apps';
import NavTranslationVariant from 'translations/variants/nav';
const translateNav = key => translate('nav', key);
const translateApps = (key: AppsTranslationVariant) => translate('apps', key);

type Props = {
  to: string;
  name: string;
  activeColor?: string;
  children?: any;
} & any;

const routeNames = routes.map(r => {
  return r.path.includes('/') ? r.path.slice(0, r.path.indexOf('/')) : r.path;
});

const isActiveBookRoute = pathname => {
  return !routeNames.find(route => pathname.includes(route));
};

export const getExplicitMatch = (name, pathname) => {
  const getPath = () => {
    switch (name) {
      case translateNav('teachersGuide'):
        return '/books/TG:bookCode/:edition/:pageNumber?/:isZoom?';
      case translateNav('lessonPlanner'):
        return '/books/:bookCode/:edition/lesson-planner';
      case translateNav('assignmentTracker'):
        return '/books/:bookCode/:edition/assignment-tracker';
      case translateApps(AppsTranslationVariant.worksheetMaker):
        return '/apps/worksheet-maker/:bookCode/:edition';
      case translateApps(AppsTranslationVariant.woodPieces):
        return '/apps/wood-pieces/:bookCode/:edition';
      case translateApps(AppsTranslationVariant.letterFormation):
        return '/apps/letter-number-formations/:bookCode/:edition';
      case translateApps(AppsTranslationVariant.wdt):
        return '/apps/wet-dry-try/:bookCode/:edition';
      case translateNav(NavTranslationVariant.support):
        return '/books/:bookCode/:edition/support';
      case translateNav('home'):
        return '/home';
    }
  };

  const match = matchPath(getPath() ?? '', pathname);
  return match;
};

export function isSelectedNameActive(name: string, pathname) {
  //TODO: Hack -- return false if we are checking for a Student Workbook menu item
  //and we have either the lesson planner, assignment tracker or resources on the URL as part of the book
  //This needs to be fixed as part of routing changes
  if (name === translateNav('studentWorkbook')) {
    if (
      pathname.includes('lesson-planner') ||
      pathname.includes('assignment-tracker') ||
      pathname.includes('resources') ||
      pathname.includes('apps') ||
      pathname.includes('support') ||
      pathname.includes('home')
    )
      return false;
  }

  const isMatch = getExplicitMatch(name, pathname);

  if (!pathname && !isMatch) return false;

  if (name === translateNav('teachersGuide') || name === translateNav('studentWorkbook')) {
    if (isActiveBookRoute(pathname)) {
      if (pathname.includes('TG') && name === translateNav('teachersGuide')) return true;

      if (!pathname.includes('TG') && name === translateNav('studentWorkbook')) return true;
    }

    return false;
  }
  return isMatch;
}

const HWTLink = ({ to, name, activeColor, children, ...props }: Props) => {
  const location = useLocation();
  const isLinkActive = isSelectedNameActive(name, location.pathname);
  return (
    <NavLink
      to={to}
      style={{
        fontWeight: isLinkActive ? 'bold' : '',
        color: isLinkActive ? activeColor : ''
      }}
      {...props}
    >
      <Typography variant="subtitle1" style={{ fontWeight: 400, fontSize: '15px' }}>
        {children || name}
      </Typography>
    </NavLink>
  );
};

export default HWTLink;
